/* eslint-disable indent */
import { Typography } from '@mui/material';
import styled from 'styled-components';

import { COLORS, light, newLayout } from 'theme';

export const BookingTypeContainer = styled.div`
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  display: flex;
  padding: ${({ theme }) => theme.spacing.s4};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s3};
  flex: 1 0 0;
  border-radius: ${({ theme }) => theme.borderRadius.primary};
  opacity: ${({ $disabled, $selected }) => ($disabled && $selected ? 0.5 : 1)};
  border: ${({ $selected, $disabled }) => {
    if ($disabled) {
      return `${COLORS.black06}`;
    }
    if ($selected) {
      return `${COLORS.kinetikBlue}`;
    }
    return COLORS.black08;
  }};
  background: ${({ $selected }) => {
    if ($selected) {
      return `${COLORS.kinetikBlue}`;
    }
    return light.app.primary;
  }};
  box-shadow: ${({ theme }) =>
    `0px ${theme.spacing.s1} ${theme.spacing.s4} 0px rgba(8, 15, 29, 0.06)`};
`;

export const IconContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing.s2};
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s1};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  border: ${({ $selected }) =>
    $selected
      ? `0.5px solid  ${COLORS.kinetikBlue}`
      : `0.5px solid  ${COLORS.black50}`};
  background: ${({ $selected }) =>
    $selected ? `${light.app.primary}` : `${COLORS.black04}`};
  svg {
    path {
      fill: ${({ $selected }) =>
        $selected ? `${COLORS.kinetikBlue}` : `${COLORS.black50}`};
    }
  }
`;

export const StyledTypography = styled(Typography)`
  && {
    color: ${({ $selected }) =>
      $selected ? `${light.app.primary}` : `${COLORS.kinetikBlack}`};

    font-family: Roboto;
    font-size: ${newLayout.fontSize.body1};
    font-weight: ${newLayout.fontWeight.medium};
    line-height: ${newLayout.lineHeight.body1};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
  }
`;
